'use client'

import { useState } from 'react'

const DEFAULT_ID = 'default' as const

export function useHandleCopy() {
  const [copiedId, setCopiedId] = useState<string | number | null>(null)

  const handleCopy = (text: string, id: string | number = DEFAULT_ID) => {
    void navigator.clipboard.writeText(text)
    setCopiedId(id)
    setTimeout(() => {
      setCopiedId(null)
    }, 2000)
  }

  const isCopied = (id: string | number = DEFAULT_ID) => copiedId === id

  return {
    copy: isCopied(DEFAULT_ID),
    copiedId,
    isCopied,
    handleCopy,
  }
}
